import { IPlayer, IPlayerOptions, IState } from '@lordicon/react/dist/interfaces';
import React from 'react';

export type ActionResponseType<T extends (...args: any[]) => Promise<any | ResponseError>> = Exclude<Awaited<ReturnType<T>>, ResponseError | null>

type PlayerState = {};
type Options = IPlayerOptions;
/** IconPlayer component */
export declare class IconPlayer extends React.Component<Options, PlayerState> implements IPlayer {
    connect(): void;
    disconnect(): void;
    play(): void;
    playFromBeginning(): void;
    pause(): void;
    goToFirstFrame(): void;
    goToLastFrame(): void;
    get frames(): number;
    get isPlaying(): boolean;
    get states(): IState[];
    get currentState(): IState;
}


/** youtube xml response interface */
export interface YouTubeFeed {
    title: string;
    link: string;
    items: YouTubeEntry[];
    feedUrl: string
}

/** youtube xml response video entry interface */
export interface YouTubeEntry {
    ytid: string,
    author: string;
    id: string;
    isoDate: string;
    link: string;
    pubDate: string;
    title: string;
    "media:group": {
        "media:thumbnail": [{
            $: {
                url: string,
                width: string,
                height: string
            }
        }],
        "media:description": string,
        "media:community": [{
            "media:starRating": [{
                $: {
                    count: number,
                }
            }],
            "media:statistics": [{
                $: {
                    views: number,
                }
            }]
        }]
    }
}

/** api/social good response interface */
export interface SocialApiResponse {
    /** the channel id */
    id: string
    /** channel name */
    name: string;
    /** the url linking to the channel */
    channel: string;
    /** channel logo */
    logo: string;
    /** subcount of the channel */
    subcount: number;
    /** is channel is currently ctreaming */
    isStreaming: boolean | undefined;
    /** the url for the live - if streaming */
    liveUrl?: string | undefined;
    /** the amount of viewers - if streaming */
    viewers?: number | undefined;
    videoID?: string | undefined;
}

export interface ResponseError {
    error: string
}

export class ResponseError {
    error: string;

    constructor(error: string) {
        this.error = error;
    }

    asErrorObj() {
        return { error: this.error }
    }
}









/**
 * 
 *  NEXT JS DEFAULT
 * 
 * 
 */

export interface LayoutProps {
    children?: React.ReactNode
    params?: any
}

export interface PageProps {
    params?: { [key: string]: string | string[] }
    searchParams?: { [key: string]: string | string[] }
}
/**
 * `auto` (default): The default option to cache as much as possible without preventing any components from opting into dynamic behavior.

`force-dynamic`: Force dynamic rendering, which will result in routes being rendered for each user at request time. This option is equivalent to:
getServerSideProps() in the pages directory.
Setting the option of every fetch() request in a layout or page to { cache: 'no-store', next: { revalidate: 0 } }.
Setting the segment config to export const fetchCache = 'force-no-store'
'error': Force static rendering and cache the data of a layout or page by causing an error if any components use dynamic functions or uncached data. This option is equivalent to:
or
getStaticProps() in the pages directory.
Setting the option of every fetch() request in a layout or page to { cache: 'force-cache' }.
Setting the segment config to fetchCache = 'only-cache', dynamicParams = false.

`error` changes the default of dynamicParams from true to false. You can opt back into dynamically rendering pages for dynamic params not generated by generateStaticParams by manually setting dynamicParams = true.

`force-static`: Force static rendering and cache the data of a layout or page by forcing cookies(), headers() and useSearchParams() to return empty values.
 */
export type Dynamic = "auto" | "force-dynamic" | "error" | "force-static"

/**
 * `false (default)`: The default heuristic to cache any fetch requests that set their cache option to 'force-cache' or are discovered before a dynamic function is used. Semantically equivalent to revalidate: Infinity which effectively means the resource should be cached indefinitely. It is still possible for individual fetch requests to use cache: 'no-store' or revalidate: 0 to avoid being cached and make the route dynamically rendered. Or set revalidate to a positive number lower than the route default to increase the revalidation frequency of a route.
 * 
 * `0`: Ensure a layout or page is always dynamically rendered even if no dynamic functions or uncached data fetches are discovered. This option changes the default of fetch requests that do not set a cache option to 'no-store' but leaves fetch requests that opt into 'force-cache' or use a positive revalidate as is.
 * 
 * `number`: (in seconds) Set the default revalidation frequency of a layout or page to n seconds.
 */
export type Revalidate = false | 0 | number